module.exports = __webpack_public_path__ + "static/img/Julius.93ea3ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bssp/Julius.jpg
// module id = 134
// module chunks = 2